import type { AccessTokenOptions, AuthHeader } from "@axio/auth";
import { isTokenExpired } from "@axio/auth";
import { authClient } from "../auth/client";

export { isTokenExpired };

export const setLogoutInProgress = (value: boolean) => authClient.setLogoutInProgress(value);

export const storeAuthTokens = (accessToken: string, refreshToken: string) =>
  authClient.storeAuthTokens(accessToken, refreshToken);

export const storeAccessToken = (accessToken: string) => authClient.storeAccessToken(accessToken);

export const clearStoredTokens = (reason?: string) => authClient.clearTokens(reason);

export const refreshAccessToken = () => authClient.refreshAccessToken();

export const getValidAccessToken = (options?: AccessTokenOptions) => authClient.getValidAccessToken(options);

export const getAuthHeader = (): Promise<AuthHeader> => authClient.getAuthHeader();

export const getStoredAccessToken = () => authClient.getStoredAccessToken();

export const getStoredRefreshToken = () => authClient.getStoredRefreshToken();
